import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  container: {
    backgroundColor: '#E0E0E0',
    marginLeft: '-11px',
    marginRight: '-11px',
    borderRadius: '24px',
    overflow: 'hidden'
  },
  step: {
    position: 'relative',
    float: 'left',
    width: '33%',
    height: '48px',
    textAlign: 'center',
    boxSizing: 'border-box',
    paddingLeft: '16px',
    paddingTop: '10px'
  },
  stepCenter: {
    width: '34%'
  },
  currentStep: {
    backgroundColor: theme.palette.primary.main
  },
  stepBefore: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    borderLeft: `16px solid #E0E0E0`,
    borderTop: `24px solid ${theme.palette.primary.main}`,
    borderBottom: `24px solid ${theme.palette.primary.main}`
  },
  stepAfter: {
    position: 'absolute',
    top: 0,
    right: '-16px',
    width: 0,
    height: 0,
    borderLeft: `16px solid ${theme.palette.primary.main}`,
    borderTop: '24px solid #E0E0E0',
    borderBottom: '24px solid #E0E0E0'
  },
  stepName: {
    fontSize: 20,
    fontWeight: 700,
    color: '#FFFFFF'
  }
});

const enhance = compose();

const StepProgressBar = enhance(({ classes, currentStep }) => {
  return (
    <div className={classes.container}>
      <div
        className={
          classes.step + (currentStep === 1 ? ` ${classes.currentStep}` : '')
        }
      >
        <span className={classes.stepName}>入力</span>
        {currentStep === 1 && <div className={classes.stepAfter} />}
      </div>

      <div
        className={`${classes.step} ${classes.stepCenter}${
          currentStep === 2 ? ` ${classes.currentStep}` : ''
        }`}
      >
        {currentStep === 2 && <div className={classes.stepBefore} />}
        <span className={classes.stepName}>確認</span>
        {currentStep === 2 && <div className={classes.stepAfter} />}
      </div>

      <div
        className={
          classes.step + (currentStep === 3 ? ` ${classes.currentStep}` : '')
        }
      >
        {currentStep === 3 && <div className={classes.stepBefore} />}
        <span className={classes.stepName}>完了</span>
      </div>
    </div>
  );
});

export default withRouter(withStyles(styles)(StepProgressBar));
